<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$('.accordion-trigger').click(function(e) {
    e.preventDefault();
    let $this = $(this);

    if ($this.next().hasClass('show')) {
        $this.removeClass('active');
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.accordion-row .accordion-data').removeClass('show');
        $this.parent().parent().find('.accordion-row .accordion-trigger').removeClass('active');
        $this.parent().parent().find('.accordion-row .accordion-data').slideUp(350);
        $this.toggleClass('active');
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});


document.addEventListener("DOMContentLoaded", function() {

   if (window.location.href === 'https://chikitsa-usa.myshopify.com/pages/our-story') {

        var targetDivs = document.querySelectorAll('.halo-row.column-3.items--full_width.slider.slider--tablet');
        targetDivs.forEach(function(div) {
          div.classList.add('new-class');
        });

       
        const contentBoxes = document.querySelectorAll('.content-box.text-center');

        if (contentBoxes.length >= 2) {
          contentBoxes[1].classList.add('second-div-ourstory');
        }
     
    }
   if (window.location.href === 'https://chikitsa-usa.myshopify.com/pages/ask-experts') {
     document.getElementById("MainContent").style.paddingBottom = "0px";
    }

  var parentDiv = document.querySelector('.sk-logo-image');

  parentDiv.style.cssText = '';
  parentDiv.style.display = 'none';

var mainDiv = document.getElementById('tab-ingredients-mobile');
    
    if (mainDiv) {
        // Select the element with the class 'flex-box__banner' within the specific hierarchy
        var flexBoxBanner = mainDiv.querySelector('#halo-image-banner-description .item-banner .flex-box__banner');
        
        if (flexBoxBanner) {
            // Apply CSS styles to the 'flex-box__banner' class
            flexBoxBanner.style.display = 'flex';
            flexBoxBanner.style.flexDirection = 'column';
        }
    }

  
});

